import { PageContainer } from "@/components/container/page-container";
import { CheckFatIcon } from "@/components/icons/check-fat-icon";
import { LogoIcon } from "@/components/icons/logo-icon";
import { SmileIconWithShadow } from "@/components/icons/smile-icon-with-shadow";
import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { DEFAULT_AUTHENTICATED_ROUTE } from "@/constants/app-routes";
import { OnboardingRoundBackground } from "@/features/user-profile/components/onboarding-round-background";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useIonRouter } from "@ionic/react";

function OnboardingPlanBuilt() {
  const navigation = useIonRouter();

  const handleShowPlan = () => {
    navigation.push(DEFAULT_AUTHENTICATED_ROUTE, "forward");
  };

  return (
    <PageContainer showToolbar={false}>
      <OnboardingRoundBackground
        classNames={{
          header: "flex flex-col items-center pt-[88px] px-8 pb-12",
          content: "flex flex-col justify-end items-center px-8 pt-8 pb-12 gap-12 !z-[100]",
        }}
        header={
          <>
            <LogoIcon className="h-[45px] w-[177px]" logoColor="white" />
            <div className="mt-12 mb-8">
              <SmileIconWithShadow />
            </div>
          </>
        }
      >
        <div className="flex w-full flex-col items-center gap-6">
          <div className="flex items-center gap-3">
            <CheckFatIcon className="text-os-bran -h-9 w-9" />
            <h1 className={textVariants.headline}>I've built your plan</h1>
          </div>

          <div className="flex w-full max-w-[324px] flex-col gap-4">
            <p className={textVariants.bodySingleLine}>
              Your plan's all set. It's designed for your lifestyle, and you can swap or adjust
              anything, any time.
            </p>
            <p className={cn(textVariants.bodySingleLine)}>I'll keep evolving with you.</p>
            <p className={textVariants.bodySingleLine}>Now let's get you on plan!</p>
          </div>
        </div>

        <div className="w-full max-w-[322px]">
          <FilledButton color="purple" textCase="uppercase" onClick={handleShowPlan}>
            Show me my plan
          </FilledButton>
        </div>
      </OnboardingRoundBackground>
    </PageContainer>
  );
}

export default OnboardingPlanBuilt;
